<template>
  <div class="cp-product-list-view">
    <b-carousel :arrow="false"
     class="section-one" icon-pack="fas" icon-size="is-large" :arrow-hover="false">
      <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
        <img :src="carousel.url" />
      </b-carousel-item>
    </b-carousel>
    <section class="section-two">
        <img src="https://ik.imagekit.io/osusf6xvdf/beta/product-leave-1_k0Su4q5cyW6.png"
        class="section-two-leave is-hidden-desktop">
        <img src="../../assets/img/product/product-section-two-bg.png" class="section-two-bg">
        <div class="">
          <img src="https://ik.imagekit.io/osusf6xvdf/beta/product-leave-1_k0Su4q5cyW6.png"
          class="section-two-upper-left is-hidden-touch">
        </div>
      <div class="section-two-content">
        <p class="cp-product-list-view-title title is-3 is-size-4-mobile has-text-black">
          <!-- {{ $t('products.all.products.label') }} -->
          PRODUCTS
        </p>
        <div class="cp-product-list-view-list columns is-multiline is-mobile is-centered">
          <div
            class="cp-product-list-view-list-item column is-12-mobile is-6-tablet is-3-desktop"
            :key="index"
            v-for="(product, index) in products"
          >
            <!-- v-for="(product, index) in products" -->
            <Product
              :otproduct="false"
              :image="product.product_image.length ? product.product_image[0] : ''"
              :title="product.product_name_localized"
              :detail="product.product_description_localized"
              :sale="product.is_discount === 'yes'"
              :price="product.price"
              :discount="product.discount"
              @click="goToProductDetail(product)"
            />
          </div>
        </div>
      </div>
    </section>

    <b-button
      v-if="hasMoreData"
      class="cp-product-list-view-load-more"
      type="is-default"
      @click="loadMore"
      :loading="loading"
      >{{ $t('products.loadmore.button') }}
    </b-button>
    <!-- <ShadowDivider class="cp-product-list-view-shadow-container" />
    <StandardSection />
    <ShadowDivider class="cp-product-list-view-shadow-container" :upside="true" />
    <SmallSellerSection /> -->
    <OrderFloatIcon />
  </div>
</template>

<script>
import { getProducts } from '@/apis/product';
import Product from '@/components/Product.vue';
import OrderFloatIcon from '@/components/OrderFloatIcon.vue';
// import ShadowDivider from '@/components/ShadowDivider.vue';
// import StandardSection from '@/components/StandardSection.vue';
// import SmallSellerSection from '@/components/SmallSellerSection.vue';

export default {
  name: 'ProductListView',
  components: {
    Product,
    OrderFloatIcon,
    // ShadowDivider,
    // StandardSection,
    // SmallSellerSection,
  },
  data() {
    return {
      carousels: [
        { url: 'https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-14_O4ZeShYB3Nu.jpg', id: 20 },
        { url: 'https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-15_cHs__qHEb_V.jpg', id: 17 },
      ],
      products: [],
      currPage: 1,
      pageSize: 8,
      loading: false,
      hasMoreData: true,
    };
  },
  async mounted() {
    const { products, total } = await getProducts(this.currPage, this.pageSize);
    this.products = products;
    if (this.products.length >= total) {
      this.hasMoreData = false;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    goToProductDetail(product) {
      this.$router.push({
        name: 'ProductDetail',
        params: {
          id: product.id,
        },
      });
    },
    async loadMore() {
      this.loading = true;

      try {
        const { products, total } = await getProducts(this.currPage + 1, this.pageSize);
        this.products = [...this.products, ...products];

        if (products.length > 0) {
          this.currPage += 1;
        }
        if (this.products.length >= total) {
          this.hasMoreData = false;
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.section-one{
  z-index: -1;
}
.section-two{
  padding-bottom: 30px;
  position: relative;
  &-bg{
    position: absolute;
    z-index: -1;
    margin-top: -10%;
    left:0%;
  }
  &-upper-left{
    position: absolute;
    display: block;
    width: 30%;
    top: -50%;
    left: 75%;
    z-index: 999;
  }
  &-content{
    z-index: 3;
    position: relative
  }
  &-leave{
    z-index: 999;
      width: 50%;
      position: absolute;
      top:-4rem;
      right: 0rem;
  }
}
.cp-product-list-view {
  text-align: center;

  &-title {
    margin-bottom: -40px;
    padding-top: 50px;
  }

  &-list {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  &-list-item:first-child {
    margin-left: auto;
  }

  &-list-item:last-child {
    margin-right: auto;
  }

  &-shadow-container {
    width: 80%;
    margin-right: auto;
    margin-left: auto;
  }

  /deep/ .cp-product {
    margin-left: auto;
    margin-right: auto;
  }

  &-load-more {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom:30px;
    padding-left: 30px;
    padding-right: 30px;
  }
}
</style>
